export function getApiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => item?.msg || item?.message)
      .filter(Boolean);
    if (messages.length) return messages.join(" ");
  }

  if (detail && typeof detail === "object") {
    return detail.message || fallback;
  }

  if (error?.code === "ERR_NETWORK") {
    return "The backend is unavailable. Check that the API and network are running.";
  }

  return error?.message || fallback;
}
